import { Component, Input, OnInit, ViewChild, afterNextRender } from '@angular/core';
import { Galleria } from 'primeng/galleria';
import { ImageService } from '@usheru-hff/shared/utils-image';
import { Image } from '@usheru-hff/shared/domain';
/**
 * //TODO docs favio
 *
 * //TODO barbeitoalex propostal - organice life cycle methods. Split in specific method to improve docs.
 */
@Component({
    selector: 'ush-branded-gallery',
    templateUrl: './branded-gallery.component.html',
    styleUrls: ['./branded-gallery.component.scss'],
    standalone: false
})
export class BrandedGalleryComponent implements OnInit {
  @Input() movieImages: Image[];
  @Input() aspectRatio?: string;

  showThumbnails: boolean;

  fullscreen = false;
  isGalleryFullScreen: boolean;
  activeIndex = 0;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFullScreenListener: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public screenWidth: any;

  @ViewChild('galleria') galleria: Galleria;

  constructor(private imageService: ImageService) {
    afterNextRender(() => {
      this.screenWidth = window.innerWidth;
    });
  }

  responsiveOptions: { breakpoint: string; numVisible: number }[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  ngOnInit() {
    if (this.movieImages[0].position) {
      this.movieImages.sort((a, b) => a.position - b.position);
    }
    this.bindDocumentListeners();
  }

  onThumbnailButtonClick() {
    this.showThumbnails = !this.showThumbnails;
  }

  toggleFullScreen() {
    if (this.fullscreen) {
      this.closePreviewFullScreen();
    } else {
      this.openPreviewFullScreen();
    }
  }

  openPreviewFullScreen() {
    const elem = this.galleria.element.nativeElement.querySelector('.p-galleria');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem['mozRequestFullScreen']) {
      /* Firefox */
      elem['mozRequestFullScreen']();
    } else if (elem['webkitRequestFullscreen']) {
      /* Chrome, Safari & Opera */
      elem['webkitRequestFullscreen']();
    } else if (elem['msRequestFullscreen']) {
      /* IE/Edge */
      elem['msRequestFullscreen']();
    }
    this.isGalleryFullScreen = true;
  }

  getGallerySrcSets(src) {
    // Example: Fetch the srcset value from an API response
    const galleryOpenSrcset =
      this.imageService.computeUrl(src, { width: 360 }) +
      ' 250w, ' +
      this.imageService.computeUrl(src, { width: 450 }) +
      ' 450w, ' +
      this.imageService.computeUrl(src, { width: 750 }) +
      ' 750w, ' +
      this.imageService.computeUrl(src, { width: 1000 }) +
      ' 1000w, ' +
      this.imageService.computeUrl(src, { width: 1500 }) +
      ' 1500w, ' +
      this.imageService.computeUrl(src, { width: 2000 }) +
      ' 2000w';
    return galleryOpenSrcset;
  }

  onFullScreenChange() {
    this.fullscreen = !this.fullscreen;
  }

  closePreviewFullScreen() {
    // if (document.exitFullscreen) {
    //   document.exitFullscreen();
    // } else if (document['mozCancelFullScreen']) {
    //   document['mozCancelFullScreen']();
    // } else if (document['webkitExitFullscreen']) {
    //   document['webkitExitFullscreen']();
    // } else if (document['msExitFullscreen']) {
    //   document['msExitFullscreen']();
    // }
    this.isGalleryFullScreen = false;
  }

  bindDocumentListeners() {
    this.onFullScreenListener = this.onFullScreenChange.bind(this);
    // document.addEventListener('fullscreenchange', this.onFullScreenListener);
    // document.addEventListener('mozfullscreenchange', this.onFullScreenListener);
    // document.addEventListener('webkitfullscreenchange', this.onFullScreenListener);
    // document.addEventListener('msfullscreenchange', this.onFullScreenListener);
  }

  unbindDocumentListeners() {
    // document.removeEventListener('fullscreenchange', this.onFullScreenListener);
    // document.removeEventListener('mozfullscreenchange', this.onFullScreenListener);
    // document.removeEventListener('webkitfullscreenchange', this.onFullScreenListener);
    // document.removeEventListener('msfullscreenchange', this.onFullScreenListener);
    this.onFullScreenListener = null;
  }

  ngOnDestroy() {
    this.unbindDocumentListeners();
  }

  galleriaClass() {
    return `custom-galleria ${this.isGalleryFullScreen ? 'fullscreen' : ''}`;
  }

  fullScreenIcon(): string {
    return `pi ${this.isGalleryFullScreen ? 'pi-window-minimize' : 'pi-window-maximize'}`;
  }
}
